import type { SVGProps } from "react";

export function TikTokIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.16-.04-.32-.04-.48V8.79c.02-1.76.67-3.47 1.78-4.83 1.27-1.56 3.12-2.61 5.18-2.87.63-.09 1.27-.11 1.91-.07zm-5.8 8.38v4.03c.01.64-.07 1.28-.26 1.89-.38 1.23-1.14 2.29-2.15 3.01-1.01.72-2.23 1.1-3.47 1.07-.75-.02-1.49-.18-2.18-.48v-4.06c.67.25 1.38.39 2.1.39.74.01 1.48-.15 2.14-.46.66-.31 1.21-.77 1.6-1.32.39-.56.62-1.21.67-1.89.04-.55.01-1.11-.12-1.65-.11-.53-.32-1.03-.61-1.48z" />
    </svg>
  );
}

export function FacebookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  );
}
